// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const QueuesIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="QueuesIcon" ref={forwardedRef} {...props}>
      <path d="M3 4.25a1 1 0 0 1 1-1h8.003a1 1 0 0 1 1 1v1h5.09v9.25h-5.22l1.017 1.017-1.062 1.062L10 13.75l2.828-2.828 1.06 1.059L12.867 13h3.725V6.75h-3.59v1.5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm4.25.5H4.5v3h2.75zm4.253 0H8.75v3h2.753z" />
      <path d="M3 11.75a1 1 0 0 1 1-1h3.75a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm4.25.5H4.5v3h2.75z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const QueuesIcon = /* @__PURE__ */ Object.assign(QueuesIconComponent, {
  displayName: 'QueuesIcon',
});
